// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//less
import less from 'less'
import './assets/js/reset'
import './assets/js/libs/jquery.min'
// element-ui
import { Dialog , Button, Form , FormItem, Input,  }  from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill';
//mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import './assets/css/base.css'

Vue.use(less)
Vue.use(MintUI);
Vue.use( Dialog );
Vue.use( Button );
Vue.use( Form );
Vue.use( FormItem);
Vue.use( Input );
import { Toast, Indicator } from 'mint-ui';
Vue.config.productionTip = false


//面向对象 ajax请求封装
Vue.prototype.newAjax = function(params){
  var that = this;
  // mock /goat
  var url = params.url;
  //var url ="/tiger-mgr/mgr"+params.url;
  var method = params.method || "GET";
  var data = params.data || {};
  var dataType = params.dataType || "json";
  var cache= params.cache == undefined ? true : params.cache;
  var processData= params.processData == undefined ? true : params.processData;
  var contentType= params.contentType == undefined ? 'application/x-www-form-urlencoded; charset=UTF-8' : params.contentType;
  var header = params.header ||{};
  var success = params.success;
  var error = params.error || function(error){

    Toast({
      message: error.responseJSON.error_description || '请求失败',
      iconClass: 'iconfont icon-error',
      duration: 3000
    });
  };
  var beforeSend = params.beforeSend || function(data){
    if (!navigator.onLine) {
      //   Indicator.open({
      //     text: '加载中...',
      //     spinnerType: 'fading-circle'
      //   });
      // } else {
      //   Indicator.close();
      alert('网络连接断开，请检查网络');
    }

  };

  $.ajax({
    url: url,
    method: method,
    data : data,
    timeout : 10000,
    dataType: dataType,
    headers: header,
    cache: cache,
    processData: processData,
    contentType: contentType,
    beforeSend : beforeSend,

    complete : function(XMLHttpRequest,status){ //请求完成后最终执行参数
      Indicator.close();
      if(status=='timeout'){//超时,status还有success,error等值的情况
        Toast({
          message: '请求超时',
          iconClass: 'iconfont icon-error'
        });
      }
    },
    success: success,
    error : error
  })
};

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js